import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-serwis24',
    templateUrl: './regulations-serwis24.component.html',
    styleUrls: ['./regulations-serwis24.component.scss']
})
export class RegulationsSerwis24Component {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
